import { createContext, type FC, type ReactElement, useState } from 'react';
import { BottomSnackBar } from '../components/Information';

type NotificationContext = {
  notifyError: (message: string) => void;
};

export const NotificationContext = createContext<NotificationContext>({} as NotificationContext);

export const NotificationProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);

  const notifyError = (message: string) => {
    setErrorMessage(message);
    setOpen(true);
  };

  return (
    <NotificationContext.Provider value={{ notifyError }}>
      {children}
      <BottomSnackBar severity="error" text={errorMessage} showBar={open} setShowBar={() => setOpen(false)} />
    </NotificationContext.Provider>
  );
};
